import {axiosApiPromise, ResponseType} from "../../api/util";
import {Email} from "../../User/model/UserInfo";
import {SERVER_CONTEXT} from "./constants";

export const sendUserFeedback = (feedbackText: string, email: Email): Promise<ResponseType> => {
    return axiosApiPromise(SERVER_CONTEXT + 'SendUserFeedback', {text: feedbackText, userEmail: email});
};
